import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { AuditLogComponent } from 'src/app/shared/audit-log/audit-log/audit-log.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-navigation-setup',
  templateUrl: './navigation-setup.component.html',
  styleUrls: ['./navigation-setup.component.scss']
})
export class NavigationSetupComponent implements OnInit {

  public _mFormGroup: FormGroup;
  public mSite = new FormControl('');
  public mRoutingType = new FormControl('');
  public mShift = new FormControl([]);

  tableViewPage: boolean = true;
  addBtnPage: boolean = false;
  title: any = 'Add';
  cities: any = [];
  pageNo: number = 1;
  _mData: any = [];
  _mCurrentNumber: number = 0;
  _mPreviousPageNumber: number = 0;
  _mTotalPage: number = 1;
  _mTotalElements: number = 0;
  _mNumberOfElements: number = 0;
  _mSize: number = 0;
  _mColumns: any = [];
  _mDataRaw: any = [];
  mSites: any;
  selectedCity: any = '';
  shiftData: any;
  editData: any = '';
  ELEMENT_DATA: any[] = [];
  searchData: any = '';
  mRoutingTypes: any[] = [{ "value": "COMMON" }, { "value": "HOME POINT" }, { "value": "ALGORITHM" }, { "value": "FIXED" }]
  subcribeEdit: boolean = false;
  auditFlag: boolean = false;
  shiftDropDownSettings = {
    singleSelection: false,
    idField: "shiftTimeId",
    textField: "shiftTime",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  constructor(private fb: FormBuilder,
    private ngxLoader: NgxUiLoaderService,
    private readonly apiService: ApiService,
    private readonly localStorage: ServiceLocalStorage,
    private notifyService: NotificationService,
    public readonly dialog: MatDialog) { }

  ngOnInit(): void {
    this._mFormGroup = this.fb.group({
      'site': this.mSite,
      'routingType': this.mRoutingType,
      'shift': this.mShift
    })
    this.getAllCities();
  }

  getAllCities() {
    let companyId = +this.localStorage.getCompanyId();
    this.apiService.doGetRequestWithResponse(ApiConstants.getLocationsByCompanyIdAndUser + companyId, (success) => {
      this.cities = success.body;
      this.selectedCity = success.body[0].locationId;
      if (this.selectedCity) {
        this.onLocationChange(this.pageNo, '');
        this.addSetup();
      }
    }, (error) => {
      this.notifyService.showError(error.message, null);
    })
  }

  onLocationChange(pageNo: number, searchkey: string) {
    this.ngxLoader.start();
    const url = `${ApiConstants.getNavigationSetupByLocationId}${this.selectedCity}&page=${pageNo - 1}&searchKey=${searchkey}`;
    this.apiService.doGetRequestWithResponse(url, (success) => {
      this.ngxLoader.stop();
      if (success.status == 200) {
        this._mDataRaw = success.body.content;
        // this._mData = this.setDataLocally(this._mDataRaw);
        this._mData = success.body.content;
        this.ELEMENT_DATA = this._mData;
        this.subcribeEdit = true;
        this.auditFlag = true;
        this._mTotalPage = success.body.totalPages;
        this._mSize = success.body.size;
        this._mTotalElements = success.body.totalElements;
        this._mNumberOfElements = success.body.numberOfElements;
        this._mColumns = [{ label: 'Site', key: 'siteName' },
        { label: 'Routing type', key: 'routingType' },
        { label: 'Status', key: 'status' }];
        this.setLocalHeaders();
      } else {
        this._mData = [];
        this._mDataRaw = [];
        this._mTotalPage = 0;
        this._mSize = 0;
        this._mTotalElements = 0;
        this._mNumberOfElements = 0;
        this._mColumns = [];
        this.ELEMENT_DATA = [];
        this.subcribeEdit = false;
        this.auditFlag = false;
        this.notifyService.showInfo("No Data Found", null);
      }
    }, (error) => {
      this.ngxLoader.stop();
      this.notifyService.showError(error.message, null);
    })
  }

  setLocalHeaders() {
    this._mColumns.forEach(obj => {
      (obj.key == 'site.siteName') ? obj.key = 'siteName' : '';
    });
  }

  // setDataLocally(data) {
  //   let navigationSetupList: any = [];
  //   data.forEach((navigation, i) => {
  //     let navigationSetup: any = {};
  //     navigationSetup.id = navigation.id;
  //     navigationSetup.siteId = navigation.site.siteId;
  //     navigationSetup.siteName = navigation.site.siteName;
  //     navigationSetup.routingType = navigation.routingType;
  //     navigationSetup.status = navigation.status;
  //     navigationSetupList.push(navigationSetup);
  //   });
  //   return navigationSetupList;
  // }

  // setDataLocally(data) {
  //   return data.map(navigation => ({
  //     id: navigation.id,
  //     siteId: navigation.site.siteId,
  //     siteName: navigation.site.siteName,
  //     routingType: navigation.routingType,
  //     status: navigation.status
  //   }));
  // }

  onNewPageRequest($event) {
    if ($event !== null || $event !== undefined)
      this.onLocationChange($event, '');
  }

  addSetup() {
    this.getSites();
    this.title = 'Add';
    this.editData = '';
    this._mFormGroup.reset();
    this.addBtnPage = true;
    this.tableViewPage = false;
    this.mRoutingType.setValue(this.mRoutingTypes[0].value);
  }

  onEditIconClicked(data) {
    this.getSites();
    this.title = 'Edit';
    this.tableViewPage = false;
    this.addBtnPage = true;
    this.editData = data.option;
    this.mSite.setValue(data.option.siteId);
    this.mRoutingType.setValue(data.option.routingType);
    this.mShift.setValue([]);
    if (this.mSite.value && this.editData.siteId) {
      this.getShiftsTimes();
    }
  }

  onBack() {
    this.addBtnPage = this.addBtnPage == true ? false : true;
    this.tableViewPage = this.tableViewPage == true ? false : true;
  }

  getSites() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getSiteListForDropDown, success => {
      if (success.status == 200) {
        this.mSites = success.body;
        if (this.mSites.length > 0) {
          this.mSite.setValue(this.mSites[0].siteId);
          this.getShiftsTimes();
        }
      } else {
        this.mSites = [];
      }
    }, error => {
      this.notifyService.showError(error.message, null);
    })
  }

  // getShiftsTimes() {
  //   this.apiService.doGetRequestWithResponse(ApiConstants.getShiftTimesListBySiteId + "?siteId=" + this.mSite.value + "&shiftType=" + 'General', success => {
  //     if (success.status == 200) {
  //       this.shiftData = success.body;
  //       if (this.editData && this.editData.id) {
  //         this.apiService.doGetRequestWithResponse(ApiConstants.getShiftTimeListByNavigationId + this.editData.id, success => {
  //           if (success.status == 200) {
  //             this.mShift.setValue(success.body);
  //           }
  //         }, error => {
  //           this.notifyService.showError(error.message, null);
  //         })
  //       }
  //     } else {
  //       this.shiftData = [];
  //     }
  //   }, error => {
  //     this.notifyService.showError(error.message, null);
  //   })
  // }

  getShiftsTimes() {
    const url = `${ApiConstants.getShiftTimesListBySiteId}?siteId=${this.mSite.value}&shiftType=General`;
    this.apiService.doGetRequestWithResponse(url, (success) => {
      this.shiftData = success.status === 200 ? success.body : [];
      if (success.status === 200) {
        if (this.editData?.shifts) {
          // this.loadEditShiftData();
          this.mShift.setValue(this.editData.shifts);
        } else if (this.shiftData.length > 0) {
          this.mShift.setValue([this.shiftData[0]]);
        }
      }
    }, (error) => {
      this.notifyService.showError(error.message, null);
    });
  }

  // loadEditShiftData() {
  //   const url = `${ApiConstants.getShiftTimeListByNavigationId}${this.editData.id}`;
  //   this.apiService.doGetRequestWithResponse(url, (success) => {
  //     if (success.status === 200) {
  //       this.mShift.setValue(success.body);
  //     }
  //   }, (error) => {
  //     this.notifyService.showError(error.message, null);
  //   });
  // }

  onSubmit() {
    this.editData?.id ? this.updateNavigation() : this.addNavigation();
  }

  // addNavigation() {
  //   let newData = {
  //     "site": {
  //       "siteId": this.mSite.value
  //     },
  //     "status": "Active",
  //     "routingType": this.mRoutingType.value,
  //     "shifts": this.mShift.value
  //   }

  //   this.apiService.doPostRequestWithResponse(ApiConstants.addNavigation, newData, (success) => {
  //     if (success.status == 201) {
  //       if (success.body.message === "Setup Already Exists") {
  //         this.tableViewPage = true;
  //         this.addBtnPage = false;
  //         this.onLocationChange(this.pageNo, '');
  //         this.notifyService.showWarning(success.body.message, null);
  //       } else {
  //         this.notifyService.showSuccess(success.body.message, null);
  //         this.tableViewPage = true;
  //         this.addBtnPage = false;
  //         this.onLocationChange(this.pageNo, '');
  //       }
  //     }
  //   }, (error) => {
  //     console.log(error);
  //   });
  // }

  // updateNavigation() {
  //   let editData = {
  //     "id": this.editData.id,
  //     "site": {
  //       "siteId": this.mSite.value
  //     },
  //     "status": this.editData.status,
  //     "routingType": this.mRoutingType.value,
  //     "shifts": this.mShift.value,
  //   }

  //   this.apiService.doPostRequestWithResponse(ApiConstants.updateNavigation, editData, (success) => {
  //     if (success.status == 200) {
  //       this.notifyService.showSuccess(success.body.message, null);
  //       this.tableViewPage = true;
  //       this.addBtnPage = false;
  //       this.onLocationChange(this.pageNo, '');
  //     }
  //   },
  //     (error) => {
  //       this.notifyService.showError(error.message, null);
  //     }
  //   );
  // }

  addNavigation() {
    const newData = {
      site: { siteId: this.mSite.value },
      status: "Active",
      routingType: this.mRoutingType.value,
      shifts: this.mShift.value
    };

    this.apiService.doPostRequestWithResponse(ApiConstants.addNavigation, newData, (success) => {
      if (success.status === 201) {
        const isWarning = success.body.message === "Setup Already Exists" || success.body.message === "Navigation Setup already exist for selected shifts";
        this.notifyService[isWarning ? 'showWarning' : 'showSuccess'](success.body.message, null);
        this.resetToTableView();
      }
    }, (error) => {
      console.log(error);
    });
  }

  updateNavigation() {
    const editData = {
      id: this.editData.id,
      site: { siteId: this.mSite.value },
      status: this.editData.status,
      routingType: this.mRoutingType.value,
      shifts: this.mShift.value
    };

    this.apiService.doPostRequestWithResponse(ApiConstants.updateNavigation, editData, (success) => {
      if (success.status === 200) {
        this.notifyService.showSuccess(success.body.message, null);
        this.resetToTableView();
      }
    }, (error) => {
      this.notifyService.showError(error.message, null);
    });
  }

  resetToTableView() {
    this.tableViewPage = true;
    this.addBtnPage = false;
    this.onLocationChange(this.pageNo, '');
  }

  onStatusChanged(data) {
    let msg = "WARNING : Are you sure want to Disable this setup ?";
    let msgKey = AppConstants.DEACTIVATE_MSG;
    if (data.option.status == AppConstants.DEACTIVE_STATUS) {
      msg = "WARNING : Are you sure want to Enable this setup ?";
      msgKey = AppConstants.ACTIVATE_MSG;
    }
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger ms-2'
      },
      buttonsStyling: false
    });
    swalWithBootstrapButtons.fire({
      title: msg,
      text: msgKey,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#f46a6a',
    }).then(result => {
      if (result.value) {
        swalWithBootstrapButtons.fire('Done', msgKey, 'success');
        this.onStatusToggled(data);
      } else {
        swalWithBootstrapButtons.fire('Cancelled', 'Deactivated', 'error');
        this.tableViewPage = true;
        this.addBtnPage = false;
        this.onLocationChange(this.pageNo, '');
      }
    });
  }

  // onStatusToggled(data) {
  //   let reqData: any = {};
  //   reqData.id = data.option.id;
  //   reqData.status =
  //     data.option.status === AppConstants.ACTIVE_STATUS
  //       ? AppConstants.DEACTIVE_STATUS
  //       : AppConstants.ACTIVE_STATUS;
  //   this.ngxLoader.start();
  //   this.apiService.doPostRequestWithResponse(ApiConstants.enabledisableNavigation + '?id=' + reqData.id + '&status=' + reqData.status, "",
  //     (success) => {
  //       this.ngxLoader.stop();
  //       if (success) {
  //         this.notifyService.showSuccess(success.body.message, null);
  //         this.onLocationChange(this.pageNo, '');
  //       }
  //     },
  //     (error) => {
  //       this.ngxLoader.stop();
  //       this.notifyService.showError(error.message, null);
  //       this.onLocationChange(this.pageNo, '');
  //     }
  //   );
  // }

  onStatusToggled(data) {
    const { id, status } = data.option;
    const newStatus = status === AppConstants.ACTIVE_STATUS ? AppConstants.DEACTIVE_STATUS : AppConstants.ACTIVE_STATUS;
    const url = `${ApiConstants.enabledisableNavigation}?id=${id}&status=${newStatus}`;
    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(url, "", (success) => {
      this.ngxLoader.stop();
      this.notifyService[success ? 'showSuccess' : 'showError'](success?.body?.message || 'Operation failed', null);
      this.onLocationChange(this.pageNo, '');
    }, (error) => {
      this.ngxLoader.stop();
      this.notifyService.showError(error.message, null);
      this.onLocationChange(this.pageNo, '');
    });
  }

  onAuditLogClicked(e) {
    console.log(e.option)
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(ApiConstants.navigationAudit + e.option.id, (success) => {
      this.ngxLoader.stop();
      if (success.status == 200) {
        let data = success.body;
        let object = Object.entries(e.option);
        data.data.push(object[2]);
        this.dialog.open(AuditLogComponent, {
          autoFocus: false,
          maxHeight: '80vh',
          data: data,
          disableClose: true
        });
      } else {
        this.notifyService.showWarning("No audit logs found", null);
      }
    }, (error) => {
      this.ngxLoader.stop();
      console.log(error);
    }
    );
  }

  onSelectAll(event) {
  }

  onItemSelect(event) {
  }

  onSearchKey(searchKey) {
    if (searchKey.length >= 3) {
      this._mData = this.ELEMENT_DATA.filter(data => data.siteName.toLowerCase().includes(searchKey.toLowerCase()));
      if (this._mData.length == 0) {
        this._mColumns = [];
        this.subcribeEdit = false;
        this.auditFlag = false;
      }
    } else {
      if (searchKey.length == 0) {
        this.onLocationChange(this.pageNo, '');
      }
    }
  }

}
